import noUiSlider from 'nouislider';

/**
 * Slider.
 *
 * Documentation: https://refreshless.com/nouislider/
 *
 * @param  {object} options: {
 *   elementId: slider container id
 *   min: Minimum slider value
 *   max: Maksimum slider value
 *   initialMin: Initial minimum value
 *   initialMax: Initial maksimum value
 *   step: step value
 *   onUpdateCallback: Callback function on update event
 * }
 * @return {object}
 */
function slider(options) {
    const {
        elementId,
        min,
        max,
        initialMin,
        initialMax,
        onUpdateCallback,
        step,
    } = options;

    const nonLinearSlider = document.getElementById(elementId);

    // Nužda za postavljanjem ograničenja je definirana u: https://home/issues/37658
    let minimalValue = 0;
    let maximalValue = 200;

    if (max) maximalValue = max;
    if (min) minimalValue = min;

    if (step) {
        noUiSlider.create(nonLinearSlider, {
            connect: true,
            behaviour: 'tap',
            start: [initialMin, initialMax],
            step,
            range: {
                min: [minimalValue],
                max: [maximalValue],
            },
        });
    } else {
        noUiSlider.create(nonLinearSlider, {
            connect: true,
            behaviour: 'tap',
            start: [initialMin, initialMax],
            range: {
                min: [minimalValue],
                '1%': [0, 10],
                max: [maximalValue],
            },
        });
    }

    nonLinearSlider.noUiSlider.on('update', (values) => {
        const minValue = Number(values[0]);
        const maxValue = Number(values[1]);
        onUpdateCallback(minValue, maxValue);
    });

    return {
        clear() {
            nonLinearSlider.noUiSlider.set([minimalValue, maximalValue]);
        },
        /* eslint no-shadow: ["error", { "allow": ["maximalValue", "minimalValue"] }] */
        setValues(minimalValue, maximalValue) {
            nonLinearSlider.noUiSlider.set([minimalValue, maximalValue]);
        },
    };
}

export default slider;
